import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [{
		path: '*',
		redirect: '/group'
	},
	// {
	//   name: 'home',
	//   component: () => import('./view/home/index'),
	// },
	// {
	//   name: 'about',
	//   component: () => import('./view/about/index'),
	// },{
	//   name: 'info',
	//   component: () => import('./view/information/index'),
	// },{
	//   name: 'privacy',
	//   component: () => import('./view/privacy/index'),
	// },{
	//   name: 'protocol',
	//   component: () => import('./view/protocol/index'),
	// },{
	//   name: 'service',
	//   component: () => import('./view/service/index'),
	// },
	{
		name: 'group',
		component: () => import('./view/wx/chose-code'),
		meta: {
			title: '全国研友交流群',
			auth: false // 如果此路由需要微信授权请设置为true,默认为false
		}
	},
	{
		name: 'group/:id(\\w+)',
		component: () => import('./view/wx/chose-code'),
		meta: {
			title: '小白考研专业课交流群',
			auth: false // 如果此路由需要微信授权请设置为true,默认为false
		}
	},
	// {
	//   name: 'personal',
	//   component: () => import('./view/wx/chose-code/personal-add'),
	//   meta: {
	//     title: '小白考研',
	//     auth: false // 如果此路由需要微信授权请设置为true,默认为false
	//   }
	// },
	,
	{
		name: 'lc',
		component: () => import('./view/wx/chose-code/lc'),
		meta: {
			title: '小白考研',
			auth: false // 如果此路由需要微信授权请设置为true,默认为false
		}
	},
	{
		name: 'tj-query',
		component: () => import('./view/wx/chose-code/tj-query'),
		meta: {
			title: '调剂信息服务',
			auth: false // 如果此路由需要微信授权请设置为true,默认为false
		}
	},
	{
		name: 'order-query',
		component: () => import('./view/wx/chose-code/order-query'),
		meta: {
			title: '小白考研复试口语模板',
			auth: false // 如果此路由需要微信授权请设置为true,默认为false
		}
	},
	{
		name: 'order-query2',
		component: () => import('./view/wx/chose-code/order-query2'),
		meta: {
			title: '小程序获取兑换码',
			auth: false // 如果此路由需要微信授权请设置为true,默认为false
		}
	},
	{
		name: 'address-query',
		component: () => import('./view/wx/chose-code/address-query'),
		meta: {
			title: '小白收货查询',
			auth: false // 如果此路由需要微信授权请设置为true,默认为false
		}
	},
	{
		name: 'exchange-query',
		component: () => import('./view/exchange-query/exchange-query'),
		meta: {
			title: '兑换码查询',
			auth: false // 如果此路由需要微信授权请设置为true,默认为false
		}
	},
	{
		name: 'exchange-query/:id(\\w+)',
		component: () => import('./view/exchange-query/exchange-query'),
		meta: {
			title: '兑换码查询',
			auth: false // 如果此路由需要微信授权请设置为true,默认为false
		}
	},
	{
		name: 'address-query/:id(\\w+)',
		component: () => import('./view/wx/chose-code/address-query'),
		meta: {
			title: '小白收货查询',
			auth: false // 如果此路由需要微信授权请设置为true,默认为false
		}
	},
	{
		name: 'choose-service',
		component: () => import('./view/wx/chose-code/choose-service'),
		meta: {
			title: '小白考研售后服务',
			auth: false // 如果此路由需要微信授权请设置为true,默认为false
		}
	},

	{
		name: 'share',
		component: () => import('./view/wx/chose-code/share'),
		meta: {
			title: '请帮我免费订阅更多院校',
			auth: false // 如果此路由需要微信授权请设置为true,默认为false
		}
	},
	{
		name: 'shareAdjustment',
		component: () => import('./view/wx/chose-code/shareAdjustment'),
		meta: {
			title: '请帮我免费订阅更多院校',
			auth: false // 如果此路由需要微信授权请设置为true,默认为false
		}
	},
	{
		name: 'appShareAdjustment',
		component: () => import('./view/wx/chose-code/appShareAdjustment'),
		meta: {
			title: '请帮我免费订阅更多院校',
			auth: false // 如果此路由需要微信授权请设置为true,默认为false
		}
	},
	{
		name: 'appShare',
		component: () => import('./view/wx/chose-code/appShare'),
		meta: {
			title: '请帮我免费订阅更多院校',
			auth: false // 如果此路由需要微信授权请设置为true,默认为false
		}
	},
	{
		name: 'login',
		component: () => import('./view/wx/chose-code/login'),
		meta: {
			title: '登录',
			auth: false // 如果此路由需要微信授权请设置为true,默认为false
		}
	},
	{
		name: 'loginCode',
		component: () => import('./view/wx/chose-code/loginCode'),
		meta: {
			title: '登录验证',
			auth: false // 如果此路由需要微信授权请设置为true,默认为false
		}
	},
	{
		name: 'sch-info',
		component: () => import('./view/sch-info/sch-info'),
		meta: {
			title: '院校资讯详情',
			auth: false // 如果此路由需要微信授权请设置为true,默认为false
		}
	},
	{
		name: 'download',
		component: () => import('./view/download/download'),
		meta: {
			title: '下载',
			auth: false // 如果此路由需要微信授权请设置为true,默认为false
		}
	},
	{
		name: 'group_qq',
		component: () => import('./view/group-qq/group-qq'),
		meta: {
			title: '全国研友群',
			auth: false // 如果此路由需要微信授权请设置为true,默认为false
		}
	},
	{
		name: 'feedback',
		component: () => import('./view/feedback/feedback'),
		meta: {
			title: '小白，快帮我建群',
			auth: false // 如果此路由需要微信授权请设置为true,默认为false
		}
	}, {
		name: 'course_ad_01',
		component: () => import('./view/advertisement/course_ad_01'),
		meta: {
			title: '扫码添加',
			auth: false // 如果此路由需要微信授权请设置为true,默认为false
		}
	}, {
		name: 'html',
		component: () => import('./view/html/html'),
		meta: {
			title: '研小白',
			auth: false // 如果此路由需要微信授权请设置为true,默认为false
		}
	},
	{
		name: 'vip',
		component: () => import('./yy/vip/vip'),
		meta: {
			title: '会员',
			auth: false // 如果此路由需要微信授权请设置为true,默认为false
		}
	},
	{
		name: 'vipT',
		component: () => import('./yy/vip/vipT'),
		meta: {
			title: '会员',
			auth: false // 如果此路由需要微信授权请设置为true,默认为false
		}
	},
	{
		name: 'signIn',
		component: () => import('./yy/signIn'),
		meta: {
			title: '登录',
			auth: false // 如果此路由需要微信授权请设置为true,默认为false
		}
	},
  {
  	name: 'certificates',
  	component: () => import('./yy/authenticationCertificates'),
  	meta: {
  		title: '学历认证',
  		auth: false // 如果此路由需要微信授权请设置为true,默认为false
  	}
  },
  {
  	name: 'certificatesSignIn',
  	component: () => import('./yy/authenticationCertificates/signIn'),
  	meta: {
  		title: '学历认证',
  		auth: false // 如果此路由需要微信授权请设置为true,默认为false
  	}
  }
]

// add route path
routes.forEach(route => {
	route.path = route.path || '/' + (route.name || '')
})

const router = new Router({
	routes
})

router.beforeEach((to, from, next) => {
	const title = to.meta && to.meta.title
	if (title) {
		document.title = title
	}
	next()
})

export {
	router
}





